export default "__VITE_ASSET__zaLl0lO8__"